import angular from 'angular';

import MenuComponent from './menu.component';

export default angular.module('menu', [])
    .component('menuComponent', MenuComponent)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/menu/menu.module.js
// module id = 348
// module chunks = 0